// 에피소드 진단 상세의 품질 후보(`quality_candidates`) wire 경계다.
//
// Owns:
// - 후보 종류의 이름. 화면은 이 이름으로 아는 종류만 고른다. 모르는 종류를 영상 정지로 그리지 않는다.
// - 배포 기간 호환: 필드가 없으면(구 BE) 미분석으로 읽는다.
//
// Does not own:
// - 후보를 타임라인 행·칩으로 바꾸는 규칙. `diagnostics/segments/qualityCandidates` 가 소유한다.
// - 목록 필터의 후보 상태 축. `datasetEpisode.ts` 의 `EpisodeQualityCandidate` 가 소유한다.

import type { EpisodeDiagnosticDetailResp, QualityCandidatesResp } from "./diagnostics";

/** 영상 정지 후보의 종류 이름이다. 리뷰어가 붙이는 결함 값과 같은 이름이다. */
export const VIDEO_FREEZE_CANDIDATE_KIND = "video_freeze";

const UNANALYZED: QualityCandidatesResp = {
  state: "unanalyzed",
  analysis_version: null,
  items: [],
  checks: [],
};

/**
 * 상세 응답의 품질 후보를 반환한다. 필드가 없으면 미분석으로 읽는다. 구 BE 는 이 필드를 보내지
 * 않는다. 그때 후보가 없다고 단정하지 않는다.
 */
export function qualityCandidatesOf(
  detail: Pick<EpisodeDiagnosticDetailResp, "quality_candidates">,
): QualityCandidatesResp {
  // @compat ZERG-890 until=be:6eac17c2
  return detail.quality_candidates ?? UNANALYZED;
}
